import { activeBeat, type BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import { timelineRailAxisY } from "../../marker/MarkerMetrics/metrics";
import { activeBranchOffsetY } from "../../rail/RailBranchMotion/motion";
import { computeSceneMotion } from "@/lib/timeline/scene/SceneMotion/motion";
import type { TimelineViewTransform } from "../ViewTransform/transform";
import { viewTransformCenteredOn } from "../ViewTransform/transform";

/** Pan to keep the cast on the rail centered; zoom is held fixed (manual level). */
export function computeTimelineFollowView(
  layout: BookTimelineLayout,
  stageW: number,
  stageH: number,
  viewportWidth: number,
  playheadMs: number,
  zoom: number,
): TimelineViewTransform {
  const motion = computeSceneMotion(
    playheadMs,
    viewportWidth,
    layout.totalDurationMs,
  );
  const beat = activeBeat(layout, playheadMs);
  const label = beat?.locationPath?.[0] ?? beat?.locationLabel ?? "";
  return viewTransformCenteredOn(
    motion.groupCenterX,
    timelineRailAxisY() + activeBranchOffsetY(layout.rail.branches, label, playheadMs),
    zoom,
    stageW,
    stageH,
  );
}
